<template>
    <layout-gestao v-cloak>
        <div class="row">
            <div class="col-sm-12">
                <form autocomplete="off" method="post" data-vv-scope="form" @keyup.enter="saveItem" @submit.prevent="">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-9">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-name"
                                    name="name"
                                    v-model.trim="form.name"
                                    v-validate="'required|min:3'"
                                    :inputClasses="[{'is-invalid': fnHasError('name') }]"
                                    :error=" fnFirstError('name')">
                                    {{ $t(`${pageID}.model.name`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <MaterialColorPicker
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-color"
                                    name="color"
                                    v-model.trim="form.color"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('color') }]"
                                    :error=" fnFirstError('color')">
                                    {{ $t(`${pageID}.model.color`) }}
                                </MaterialColorPicker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="number"
                                    class="city-form-group city-bg"
                                    id="input-order"
                                    name="order"
                                    v-model.trim="form.order"
                                    v-validate="'required|integer|min_value:1'"
                                    :inputClasses="[{'is-invalid': fnHasError('order') }]"
                                    :error=" fnFirstError('order')"
                                    :helpText="$t(`${pageID}.help.order`)">
                                    {{ $t(`${pageID}.model.order`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-guest"
                                    name="guest"
                                    label="name"
                                    :filterable="true"
                                    :options="lists.onoff"
                                    v-model.trim="form.guest"
                                    :reduce="option => option.code"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('guest') }]"
                                    :error=" fnFirstError('guest')"
                                    :helpText="$t(`${pageID}.help.guest`)">
                                    {{ $t(`${pageID}.model.guest`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-5">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-transform_to"
                                    name="transform_to"
                                    label="name"
                                    :filterable="true"
                                    :options="lists.transform"
                                    v-model.trim="form.transform_to"
                                    :helpText="$t(`${pageID}.help.transform_to`)">
                                    {{ $t(`${pageID}.model.transform_to`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-first_process"
                                    name="first_process"
                                    label="name"
                                    :filterable="true"
                                    :options="lists.onoff"
                                    v-model.trim="form.first_process"
                                    :reduce="option => option.code"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('first_process') }]"
                                    :error=" fnFirstError('first_process')"
                                    :helpText="$t(`${pageID}.help.first_process`)">
                                    {{ $t(`${pageID}.model.first_process`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-last_process"
                                    name="last_process"
                                    label="name"
                                    :filterable="true"
                                    :options="lists.onoff"
                                    v-model.trim="form.last_process"
                                    :reduce="option => option.code"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('last_process') }]"
                                    :error=" fnFirstError('last_process')"
                                    :helpText="$t(`${pageID}.help.last_process`)">
                                    {{ $t(`${pageID}.model.last_process`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-report_to"
                                    name="report_to"
                                    label="name"
                                    :filterable="true"
                                    :options="lists.onoff"
                                    v-model.trim="form.report_to"
                                    :reduce="option => option.code"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('report_to') }]"
                                    :error=" fnFirstError('report_to')"
                                    :helpText="$t(`${pageID}.help.report_to`)">
                                    {{ $t(`${pageID}.model.report_to`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                    </div>
                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        @save="saveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)"
                    >
                    </buttons-footer>
                </form>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
    import mixin from '../../mixin'
    import MaterialColorPicker from '@/components/form/MaterialColorPicker'

    export default {
        components: {
            MaterialColorPicker
        },
        mixins: [mixin],
        data() {
            return {
                pageID: 'statuses',
                lists: {
                    transform: [],
                },
                form: {
                    id: null,
                    order: 1,
                    name: null,
                    first_process: 0,
                    last_process: 0,
                    report_to: 0,
                    color: null,
                    transform_to: null,
                    guest: 1,
                },
            }
        },
        mounted()
        {
            this.loadLists();
        },
        methods: {
            loadLists: function() {
                if (!this.lists.loaded && this.url.getTransform) {
                    this.$http.get(this.url.getTransform)
                    .then(res => {
                        this.lists.transform = res.data.data;
                        this.lists.loaded = true;
                    })
                    .catch(error => {
                        this.lists.loaded = false;
                        this.showHttpError(error);
                    });
                }
            },
        }
      }
</script>

<style scoped lang="scss">

</style>
